import { IStores } from "./index";
import * as services from "services";
import { ListStoreConstructor } from "./ListStoreConstructor";
import { BidWalletCheckGridDto } from "interfaces";

export class BidWalletCheckList extends ListStoreConstructor<BidWalletCheckGridDto> {
  id: string = "";

  setId(id: string) {
    this.id = id;
  }

  constructor(stores: IStores) {
    super(
      stores,
      (params) => {
        return services.getBidWalletCheckList({ id: this.id }, params).then(
          (response) =>
            ({
              content: response.content || [],
              size: response.size || 0,
              totalPages: response.totalPages || 0,
              totalElements: response.totalElements || 0,
            }) as any
        );
      },
      {
        pollingInterval: 10000,
        sorters: {
          created: "desc",
        },
      }
    );
  }
}
